import React from 'react'

export default props => (
  <footer className='footer-area bg-img bg-overlay-2 section-padding-100-0'>
    {/* <!-- Main Footer Area --> */}
    <div className='main-footer-area'>
      <div className='container'>
        <div className='row'>
          {/* <!-- Single Footer Widget Area --> */}
          <div className='col-12 col-sm-6 col-lg-3'>
            <div className='single-footer-widget mb-60 wow fadeInUp' data-wow-delay='300ms'>
              {/* <!-- Footer Logo --> */}
              <a href='https://www.robochef.co' className='footer-logo'><img src='/img/core-img/vertical-log.png' alt='RoboChef - Robotic Kitchen India' /></a>
              <p>India's First Robotic Restaurant.</p>

              {/* <!-- Social Info --> */}
              <div className='social-info'>
                <a href='https://www.instagram.com/robotickitchenindia/'><i className='zmdi zmdi-instagram' /></a>
                <a href='https://twitter.com/RoboticKitchen'><i className='zmdi zmdi-twitter' /></a>
                <a href='https://www.youtube.com/channel/UCjuIHhvnVUxa97B7gLFIHTQ'><i className='zmdi zmdi-youtube' /></a>
              </div>
            </div>
          </div>

          {/* <!-- Single Footer Widget Area --> */}
          <div className='col-12 col-sm-6 col-lg-3'>
            <div className='single-footer-widget mb-60 wow fadeInUp' data-wow-delay='300ms'>
              {/* <!-- Widget Title --> */}
              <h5 className='widget-title'>Contact</h5>

              {/* <!-- Contact Area --> */}
              <div className='footer-contact-info'>
                <p><i className='zmdi zmdi-map' /> 
                    Robotic Kitchen India <br />
                    {/* #67, 2c Devadaya,  <br />
                    Gandhinagar 1st Mainroad, Adyar<br /> */}
                    Chennai <br /></p>
                    {/* <a href="tel:+919789968765"><p><i className='zmdi zmdi-phone' /> +91 97899 68765</p></a> */}
                    <a href="tel:+919940432545"><p><i className='zmdi zmdi-phone' /> +91 99404 32545</p></a>
                    <a href="mailto:robotickitchenindia@gmail.com"><p><i className='zmdi zmdi-email' /> robotickitchenindia@gmail.com</p></a>
                <p><i className='zmdi zmdi-globe' /> robochef.co</p>
              </div>
            </div>
          </div>

          {/* <!-- Single Footer Widget Area --> */}
          <div className='col-12 col-sm-6 col-lg-3'>
            <div className='single-footer-widget mb-60 wow fadeInUp' data-wow-delay='300ms'>
              {/* <!-- Widget Title --> */}
              <h5 className='widget-title'>Useful Links</h5>

              {/* <!-- Footer Nav --> */}
              <ul className='footer-nav'>
                <li><a href='/'>Home</a></li>
                <li><a href='#about' id='scroll-about'>About us</a></li>
                <li><a href='#services' id='scroll-services'>Dishes</a></li>
                <li><a href='#contact' id='scroll-contact'>Contact</a></li>
              </ul>
            </div>
          </div>

          {/* <!-- Single Footer Widget Area --> */}
          <div className='col-12 col-sm-6 col-lg-3'>
            <div className='single-footer-widget mb-60 wow fadeInUp' data-wow-delay='300ms'>
              {/* <!-- Widget Title --> */}
              <h5 className='widget-title'>Gallery</h5>

              {/* <!-- Footer Gallery --> */}
              <div className='footer-gallery'>
                <div className='row'>
                  <div className='col-4'>
                    <a href='/' className='single-gallery-item'><img src='https://res.cloudinary.com/drnr4bvbs/image/upload/v1563275488/keasari_hvtghb.jpg' alt='Microsoft Azure Training in Chennai. Microsoft Azure Training in Bangalore' /></a>
                  </div>
                  <div className='col-4'>
                    <a href='/' className='single-gallery-item'><img src='https://res.cloudinary.com/drnr4bvbs/image/upload/v1563349221/coconut-rice_rrop6z.jpg' alt='Service Discovery Training in Chennai. Service Discovery Training in Bangalore' /></a>
                  </div>
                  <div className='col-4'>
                    <a href='/' className='single-gallery-item'><img src='https://res.cloudinary.com/drnr4bvbs/image/upload/v1563197101/rava-kichadi_rvlrgc.jpg' alt='Apache Hadoop Training in Chennai. Apache Hadoop Training in Bangalore' /></a>
                  </div>
                  <div className='col-4'>
                    <a href='/' className='single-gallery-item'><img src='https://res.cloudinary.com/drnr4bvbs/image/upload/v1563347179/potato-fry_q4mp9t.jpg' alt='Ansible Training in Chennai. Ansible Training in Bangalore' /></a>
                  </div>
                  <div className='col-4'>
                    <a href='/' className='single-gallery-item'><img src='https://res.cloudinary.com/drnr4bvbs/image/upload/v1563457353/s-pongal_w53oup.jpg' alt='Terraform Training in Chennai. Terraform Training in Bangalore' /></a>
                  </div>
                  <div className='col-4'>
                    <a href='/' className='single-gallery-item'><img src='https://res.cloudinary.com/drnr4bvbs/image/upload/v1563347179/tamarind-rice_iva7ob.jpg' alt='Chef Training in Chennai. Chef Training in Bangalore' /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* <!-- Copywrite Area --> */}
    <div className='container'>
      <div className='copywrite-content'>
        <div className='row'>
          {/* <!-- Copywrite Text --> */}
          <div className='col-12 col-md-6'>
            <div className='copywrite-text'>
              <p>
                {/* <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. --> */}
                Copyright &copy;<script>document.write(new Date().getFullYear());</script> All rights reserved | This template is made with <i className='fa fa-heart-o' aria-hidden='true' /> by <a href='https://colorlib.com' target='_blank'>Colorlib</a>
                {/* <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. --> */}
              </p>
            </div>
          </div>
          {/* <!-- Footer Menu --> */}
          <div className='col-12 col-md-6'>
            <div className='footer-menu'>
              <ul className='nav'>
                {/* <li><a href='#'><i className='zmdi zmdi-circle' /> Terms of Service</a></li>
                <li><a href='#'><i className='zmdi zmdi-circle' /> Privacy Policy</a></li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
)
